module.exports = __webpack_public_path__ + "img/chevron-compact-2-down.5bb52e21.svg";